module.exports = __webpack_public_path__ + "static/charles-9b6689549158174bd7ab30b6072b1709.png";